
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import type { SelectReviewUI } from '@xt/client/entities/course-v2/types.d'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class SelectReviewPop extends Vue {
  homeworks: Array<SelectReviewUI> = []
  visible: boolean = false

  hide() {
    this.visible = false
  }

  open(data: Array<SelectReviewUI>) {
    this.homeworks = data
    this.visible = true
  }

  get Store() {
    return this.$store.$courseV2.UserContent
  }

  async handleChooseReview(homeworkId: number) {
    const res = await this.Store.chooseReview(homeworkId)

    if (res === true) {
      this.$message.success('更换成功')
      this.$emit('refresh')
    }

    this.hide()
  }

  @Emit('closed')
  onClosed() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
